
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  SimpleError,
} from '../models';
import {
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
} from '../models';

export interface ComputeStatisticsRequest {
    profileId: string;
}

export interface FixInvitationRequest {
    profileId: string;
    body: string;
}

/**
 * 
 */
export class DevToolsApi extends runtime.BaseAPI {

    /**
     * Recompute answering statistics 
          */
    async computeStatisticsRaw(requestParameters: ComputeStatisticsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling computeStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/dev/{profileId}/compute-statistics`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Recompute answering statistics 
          */
    async computeStatistics(requestParameters: ComputeStatisticsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.computeStatisticsRaw(requestParameters, initOverrides);
    }

    /**
     * Try to fix an invitation and maybe attribute some point 
          */
    async fixInvitationRaw(requestParameters: FixInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling fixInvitation().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling fixInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/dev/{profileId}/invitation-point`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return response;
    }

    /**
     * Try to fix an invitation and maybe attribute some point 
          */
    async fixInvitation(requestParameters: FixInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.fixInvitationRaw(requestParameters, initOverrides);
    }

}
